// @flow
import * as React from 'react'
import {translate} from 'react-i18next'
import styled from 'styled-components'
import {
  Banner,
  Section,
  Link,
  SectionImage,
  styles,
  Traits,
  Trait
} from 'tutellus-ui'

import {Page} from './Page'

const HowItLooksSection = styled(Section)`
    position: relative;

    & ${SectionImage} {
        margin-bottom: 3.75em !important;
        @media ${styles.media.tablet} {
          margin-bottom: -3em !important;
        }
    }

    & ${Link} {
        position: absolute;
        bottom: 0;
        margin-bottom: 2em;
        transform: translateX(-50%);
        width: calc(100% - 2em);
        @media ${styles.media.tablet} {
          width: auto;
        }
    }

`
export const Certificates = translate('certificates')(({t}) =>
  <Page>
    <Banner title={t('title')} background_url={t('background_url')}>
      <p>{ t('description') }</p>
      <Link button primary
        href={t('urls:courses')}
      >
        { t('find_courses') }
      </Link>
    </Banner>
    <Section title={t('how_it_works_title')}>
      <Traits>{
        JSON.parse(t('features')).map(feature =>
          <Trait key={feature}
            title={t(`${feature}_title`)}
            icon={t(`${feature}_icon`)}>
            { t(`${feature}_description`) }
          </Trait>
        )
      }</Traits>
    </Section>
    <Section light title={t('validation_title')}>
      <p>{ t('validation_description') }</p>
      <Traits>{
        JSON.parse(t('validation_features')).map(feature =>
          <Trait key={feature}
            title={t(`${feature}_validation_title`)}
            image={t(`${feature}_validation_image`)}>
            { t(`${feature}_validation_description`) }
          </Trait>
        )
      }</Traits>
    </Section>
    <HowItLooksSection dark title={t('how_it_looks_title')}
      image={t('how_it_looks_image')}
    >
      <Link button primary
        href={t('urls:register')}
      >
        { t('register') }
      </Link>
    </HowItLooksSection>
  </Page>
)



// WEBPACK FOOTER //
// ./src/pages/Certificates.js